// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ratb78Kdse5k5I_cjWG2{display:flex}.ratb78Kdse5k5I_cjWG2 svg{flex:0 0 18px}.ratb78Kdse5k5I_cjWG2+.ratb78Kdse5k5I_cjWG2{margin-top:12px}.ratb78Kdse5k5I_cjWG2 .kZGxJflyxsffevmbhEVA{margin-left:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ratb78Kdse5k5I_cjWG2`,
	"meta": `kZGxJflyxsffevmbhEVA`
};
module.exports = ___CSS_LOADER_EXPORT___;
